import { TipoLogradouro } from '@tivic-team/manager-ts/dist/grl';

export class TipoLogradouroDTO extends TipoLogradouro {

    constructor() {
        super()
    }
}